import axios from "axios";

const token = sessionStorage.getItem("archer-user-token");

export default axios.create({
  responseType: "json",
  headers: {'Authorization': 'JWT ' + token}
});